import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventsService} from '../../../../../../../../../../@shared/services/events-service';
import {_AQH_EVE_12} from '../../../../../../../../../../@shared/models/input.module';
import {EventResponse} from '../../../../../../../../../../@shared/models/response.module';
import {ToastService} from '../../../../../../../../../../@core/services/toast.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-add-event-service',
  standalone: false,
  templateUrl: './add-event-service.html',
  styleUrl: './add-event-service.css'
})
export class AddEventService implements OnInit {
  @Input() event: EventResponse
  event_service_name: string = ''
  event_service_description: string = ''
  max_num_registrations: number
  price: number
  price_currency: string = 'NOK'
  vat_rate: number = 0

  vatRateOptions = [
    { value: 0, label: '0%' },
    { value: 12.5, label: '12.5%' },
    { value: 25, label: '25%' }
  ];

  currencyOptions = [
    { code: 'NOK', name: 'NOK' },
    { code: 'SEK', name: 'SEK' },
    { code: 'EUR', name: 'EUR' },
    { code: 'USD', name: 'USD' },
    { code: 'GBP', name: 'GBP' },
    { code: 'DKK', name: 'DKK' },
  ];

  submitted: boolean = false;
  saving: boolean = false;
  isFree: boolean = false;

  constructor(private modal: NgbActiveModal,
              private eventService: EventsService,
              private toastService: ToastService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeCurrency();
  }

  initializeCurrency() {
    // Set currency from event's default_currency (which was set during event creation)
    if (this.event?.default_currency) {
      this.price_currency = this.event.default_currency;
    }
  }

  // Validation helpers
  get isServiceNameInvalid(): boolean {
    return this.submitted && !this.event_service_name.trim();
  }

  get isFormValid(): boolean {
    return !!this.event_service_name.trim();
  }

  close() {
    this.modal.close();
  }

  toggleFree(checked: boolean) {
    this.isFree = checked;
    if (checked) {
      this.price = null as any;
      this.vat_rate = 0;
    }
  }

  addEvent() {
    this.submitted = true;

    if (!this.isFormValid) {
      this.toastService.error(this.translateService.instant('manageEvent.addService.validationError'));
      return;
    }

    this.saving = true;

    let params: _AQH_EVE_12 = {
      event_id: this.event.event_id,
      event_service_name: this.event_service_name.trim(),
      event_service_description: this.event_service_description,
      max_num_registrations: this.max_num_registrations,
      price: this.price,
      price_currency: this.price_currency,
      vat_rate: this.vat_rate
    }
    this.eventService.addEventService(params).subscribe({
      next: (data) => {
        console.log("Added Event Service: ", data);
        this.saving = false;
        this.toastService.success(this.translateService.instant('manageEvent.addService.success'));
        this.modal.close(true);
      },
      error: (err) => {
        this.saving = false;
        this.toastService.error(err.error?.reason || this.translateService.instant('manageEvent.addService.error'));
      }
    });
  }

  /**
   * Calculate net amount after platform + payment fees
   * Stripe: 2.4% + 2.00 NOK, Platform: 2%
   * Net = price × 0.956 - 2.00
   */
  calculateNetAmount(price: number): number {
    if (!price || price <= 0) return 0;
    const net = price * 0.956 - 2;
    return Math.max(0, Math.round(net * 100) / 100);
  }
}
